const _ = global._;

const Helpers = {
    clickHomeIcon: () => {
        return ({ navigate }) => {
            _.GDM.Common.settings.Remove('AssessmentPlannerModalTrialId');
            if (_.GDM.Common.ShouldNavigateToStart()) {
                navigate(`/${_.GDM.Common.HomePage()}/start`);
            }
            else {
                navigate(`/${_.GDM.Common.HomePage()}/`);
            }
        }
    }
};

export default Helpers;